import InboomaBaseModel from './InboomaBaseModel';
import Inboomai18n from '../utils/Inboomai18n';
import {Biscuit, Notification} from '../utils';
import {$, _} from "../../vendor";
import t from "../react/helpers/t";

export default InboomaBaseModel.extend({

    urlRoot : '/users',

    _save (key, val, options) {
      //this.beforeSave(key, val, options);
      return Backbone.Model.prototype.save.call(this, key, val, options);
    },

    validate (attrs) {

      let usercopy = {};
      Object.assign(usercopy,attrs);
      let errmsg = '';
      let matrixF = Object.assign({},attrs._matrixFields);
      delete attrs._matrixFields;
      _.each(matrixF, function(val, index){
        if(val.required_be && (typeof usercopy[index] === 'undefined' || usercopy[index] === '' || usercopy[index] === null)) {
          let sel = 'input[name="'+index+'"]';
          $(sel).css('border-color','red');
          let sel2 = 'select[name="'+index+'"]';
          $(sel2).css('border-color','red');
          if(errmsg === ''){
            errmsg = val.display_name;
          } else {
            errmsg += ', ' + val.display_name
          }
        }
      });
      if(errmsg !== ''){
        return errmsg + " " + t("are required");
      }
      if (attrs.email === '' || attrs.email === null) {
        delete this.attributes.email;
      }
      if(typeof attrs.username !== 'undefined' && attrs.username !== '' && attrs.username !== null){
        this.attributes.username = attrs.username.trim();
      }
      if(typeof attrs.first_name !== 'undefined' && attrs.first_name !== '' && attrs.first_name !== null){
        this.attributes.first_name = attrs.first_name.trim();
      }
      if(typeof attrs.last_name !== 'undefined' && attrs.last_name !== '' && attrs.last_name !== null){
        this.attributes.last_name = attrs.last_name.trim();
      }

    },

    _rbac : {
      "admin" : {
        "change-role" : true,
        "read-staff" : true,
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true,
      },
      "user" : {
        "change-role" : false,
        "read-staff" : false,
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "mediator" : {
        "change-role" : false,
        "read-staff" : false,
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : false
      },
      "guide" : {
        "change-role" : false,
        "read-staff" : false,
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "garage-staff" : {
        "change-role" : false,
        "read-staff" : false,
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "manager" : {
        "change-role" : true,
        "read-staff" : true,
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true
      },
      "booking-manager" : {
        "change-role" : true,
        "read-staff" : true,
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true
      },
      "manager-location" : {
        "change-role" : false,
        "read-staff" : false,
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true
      }
    },

    defaults : {
      id: "",
      username: "",
      email: "",
      first_name: "",
      last_name: "",
      company: "",
      activation_date: null,
      secret: null,
      secret_verified: null,
      tos_date: null,
      active: true,
      is_superuser: false,
      customer_nbr: null,
      role: "user",
      title: "",
      user_addresses: [],
      privacy_accepted: '',
      lang : "en_GB",
      client_id: null,
      created: "",
      created_by: "",
      modified: "",
      modified_by: "",
      deleted: "",
      user_email_settings: [],
      memberships: [],
      contract: null
  }
});
